export const T = {
  en_GB: {
    editTitle: (score: string) => `Edit Dynamic Portfolio (risk score ${score})`,
    createTitle: "Create Dynamic Portfolio",
    editDescription:
      "Update the platforms this dynamic portfolio serves and its client preference tilt",
    createDescription:
      "Create a new dynamic portfolio for a specific risk score. Products are added afterwards.",
    riskScoreHint:
      "Choose one of the risk scores defined by the assigned risk model. Several dynamic portfolios may share a score as long as their platforms do not overlap.",
    platforms: "Platforms",
    platformsHint:
      "Platforms this dynamic portfolio serves. None selected = it serves goals without a platform and can only hold products without a platform. Two dynamic portfolios of one risk score cannot share a platform.",
    preferenceTilt: "Client preference tilt",
    preferenceTiltHint:
      "The share of the portfolio one chosen client preference adds, and the share all chosen preferences add together. 0 means no tilt.",
    riskScoreRequired: "Risk score is required",
    failedToUpdate: "Failed to update dynamic portfolio",
    failedToCreate: "Failed to create dynamic portfolio",
    cancel: "Cancel",
    save: "Save",
    addDynamicPortfolio: "Add Dynamic Portfolio",
  },
  nb_NO: {
    editTitle: (score: string) => `Rediger dynamisk portefølje (risikoscore ${score})`,
    createTitle: "Opprett dynamisk portefølje",
    editDescription:
      "Oppdater plattformene denne dynamiske porteføljen gjelder for, og vridningen mot klientpreferanser",
    createDescription:
      "Opprett en ny dynamisk portefølje for en spesifikk risikoscore. Produkter legges til etterpå.",
    riskScoreHint:
      "Velg en av risikoscorene som er definert av den tilknyttede risikomodellen. Flere dynamiske porteføljer kan dele en score så lenge plattformene ikke overlapper.",
    platforms: "Plattformer",
    platformsHint:
      "Plattformer denne dynamiske porteføljen gjelder for. Ingen valgt = den gjelder for mål uten plattform og kan bare inneholde produkter uten plattform. To dynamiske porteføljer med samme risikoscore kan ikke dele en plattform.",
    preferenceTilt: "Vridning mot klientpreferanser",
    preferenceTiltHint:
      "Andelen av porteføljen én valgt klientpreferanse legger til, og andelen alle valgte preferanser legger til sammen. 0 betyr ingen vridning.",
    riskScoreRequired: "Risikoscore er påkrevd",
    failedToUpdate: "Kunne ikke oppdatere dynamisk portefølje",
    failedToCreate: "Kunne ikke opprette dynamisk portefølje",
    cancel: "Avbryt",
    save: "Lagre",
    addDynamicPortfolio: "Legg til dynamisk portefølje",
  },
} as const;
